/**
 * @generated SignedSource<<00899e449cace05ed3882fe2a0c2aaeb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type projectNotificationsConfigTable_personalSettingsNotificationsConfigTable_ProjectNotificationConfigTableNew_enabledPreferenceFragment$data = {
  readonly jira: {
    readonly notificationGlobalPreference: {
      readonly " $fragmentSpreads": FragmentRefs<"notificationsAccordianRow_personalSettingsNotificationsConfigTable_NotificationsConfigRow_enabledDataFragment" | "notificationsConfigHead_personalSettingsNotificationsConfigTable_HeadCheckbox_enabledDataFragment" | "notificationsConfigRow_personalSettingsNotificationsConfigTable_enabledDataFragment">;
    };
  };
  readonly " $fragmentType": "projectNotificationsConfigTable_personalSettingsNotificationsConfigTable_ProjectNotificationConfigTableNew_enabledPreferenceFragment";
};
export type projectNotificationsConfigTable_personalSettingsNotificationsConfigTable_ProjectNotificationConfigTableNew_enabledPreferenceFragment$key = {
  readonly " $data"?: projectNotificationsConfigTable_personalSettingsNotificationsConfigTable_ProjectNotificationConfigTableNew_enabledPreferenceFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"projectNotificationsConfigTable_personalSettingsNotificationsConfigTable_ProjectNotificationConfigTableNew_enabledPreferenceFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "projectNotificationsConfigTable_personalSettingsNotificationsConfigTable_ProjectNotificationConfigTableNew_enabledPreferenceFragment",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "args": [
                {
                  "kind": "Variable",
                  "name": "cloudId",
                  "variableName": "cloudId"
                }
              ],
              "concreteType": "JiraNotificationGlobalPreference",
              "kind": "LinkedField",
              "name": "notificationGlobalPreference",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "notificationsConfigHead_personalSettingsNotificationsConfigTable_HeadCheckbox_enabledDataFragment"
                },
                {
                  "kind": "FragmentSpread",
                  "name": "notificationsConfigRow_personalSettingsNotificationsConfigTable_enabledDataFragment"
                },
                {
                  "kind": "FragmentSpread",
                  "name": "notificationsAccordianRow_personalSettingsNotificationsConfigTable_NotificationsConfigRow_enabledDataFragment"
                }
              ]
            },
            "action": "THROW",
            "path": "jira.notificationGlobalPreference"
          }
        ]
      },
      "action": "THROW",
      "path": "jira"
    }
  ],
  "type": "Query"
};

(node as any).hash = "09d906c8b484e004b2b2e2fd2adf065a";

export default node;
